import React from 'react';
import './Header.scss';
export default () => {
  return (
    <header className="cnn-sponsorcontent-header">
        <nav className="cnn-navbar">
          <a href="https://www.cnn.com" data-analytics="header_logo" className="cnn-logo">
            <img src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png" alt="CNN Logo Badge"/>
          </a>
          <a className="back-to-cnn"href="https://www.cnn.com">&lt; Back to CNN </a>
        </nav>
        <div className="header-banner">Content by Novartis</div>
      </header>
    )
}